// snackbar module vuex
export const SNACKBAR = 'snackbar';

// state props
export const DISPLAY = 'display';
export const TEXT = 'text';
export const TIMEOUT = 'timeout';

// mutations
export const SET_DISPLAY = 'setDisplay';
export const SET_TEXT = 'setText';
